/* tt-ontwerp-bewaar (r17upsell, r19deellink): the cart links to /products/<h>?ontwerp=<_Ontwerpbestand URL>&plek=<Positie>[&stijl=&formaat=&tekst=&font=&kleur=&groep=].
   This puts that file in the product page's upload field (DataTransfer plus a change event, so the live preview and the
   form behave exactly as after a pick) and selects the place. borduur-personalisatie.liquid is not touched.
   Only https files from cdn.shopify.com or triplethread.nl are fetched; anything else is refused loudly: one visible
   sentence and console.warn, no request. A fetch that fails (other device, CORS, expired) gives the same sentence. */
(function () {
  'use strict';
  var HOSTS = ['cdn.shopify.com', 'triplethread.nl'];
  var MSG = 'We konden je ontwerp niet meenemen, upload het hier opnieuw.';
  var MAX = 25 * 1024 * 1024;
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  // r19deellink: the share link ("Deel met je groep" in the cart) carries more than the file. All values are cleaned here, once:
  //   stijl, formaat, tekst, font, kleur: matched against the buttons that exist (no match: ignored, console.warn)
  //   groep: max 40 characters, letters, digits, space, - and '. The name "1" is the group panel switch of tt-groep.js (?groep=1), not a name.
  function clean(v, max, re) { return String(v || '').replace(re, '').replace(/\s+/g, ' ').trim().slice(0, max).trim(); }
  var groep = clean(String(params.get('groep') || '').replace(/’/g, "'"), 40, /[^\p{L}\p{N} '\-]/gu);
  if (groep === '1') groep = '';
  var stijl = clean(params.get('stijl'), 60, /[<>"\u0000-\u001f]/g), formaat = clean(params.get('formaat'), 30, /[<>"\u0000-\u001f]/g);
  var tekst = clean(params.get('tekst'), 40, /[<>\u0000-\u001f]/g), font = clean(params.get('font'), 20, /[<>"\u0000-\u001f]/g), kleur = clean(params.get('kleur'), 20, /[<>"\u0000-\u001f]/g);
  var raw = params.get('ontwerp') || '', back = false, noLink = false;
  if (!params.has('ontwerp')) {
    if (!tekst) restoreExtras();
    // r17extra: "back" from the cart reloads the page without the file (browsers do not restore file fields). The last added design of
    // this product is kept in sessionStorage by tt-pdp.js; put it back, but only on back/forward and only if the field is still empty.
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      raw = (!tekst && nav && nav.type === 'back_forward' && sessionStorage.getItem('tt-ontwerp-laatste:' + location.pathname)) || '';
    } catch (e) { raw = ''; }
    noLink = !raw && !tekst && !groep && !stijl && !formaat; // r20upload: no link to apply, but the cart can still offer a design
    back = !!raw;
  }
  var linkMode = !back; // opened from a link: apply stijl and formaat too (a "back" restore keeps what the browser has)
  var plek = params.get('plek') || '';

  // r18terug: "back" from the cart also lost Ontwerp 2 to 4 (their blocks are built by script, so nothing restores them). The newest garment
  // line of this product in /cart.js is the one truth: its _tt_link groups the extra-design lines with _Ontwerpbestand, side, place and format.
  // Only on back/forward, only while no extra block exists. Any failure (offline, CORS, 404, odd file) leaves everything as it was, silently.
  function restoreExtras() {
    var nav, m;
    try { nav = performance.getEntriesByType('navigation')[0]; } catch (e) { return; }
    if (!nav || nav.type !== 'back_forward') return;
    m = /\/products\/([^/?#]+)/.exec(location.pathname);
    if (!m) return;
    var handle = decodeURIComponent(m[1]);
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (c) {
      var items = c.items || [], g = null, i;
      for (i = 0; i < items.length && !g; i++) {
        var p = items[i].properties || {};
        if (items[i].handle === handle && p._Ontwerpbestand && !p.Ontwerp && p._tt_link) g = p;
      }
      if (!g) return null;
      var ex = items.filter(function (it) { var p = it.properties || {}; return p._tt_link === g._tt_link && p.Ontwerp && p._Ontwerpbestand; })
        .sort(function (a, b) { return parseInt(a.properties.Ontwerp, 10) - parseInt(b.properties.Ontwerp, 10); }).slice(0, 3);
      return Promise.all(ex.map(function (it) {
        var p = it.properties, url = allowed(String(p._Ontwerpbestand));
        if (!url) return null;
        return fetch(url.href, { credentials: 'omit', mode: 'cors' }).then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.blob();
        }).then(function (blob) {
          var type = blob.type || '';
          if (!blob.size || blob.size > MAX || !/^(image\/|application\/pdf)/.test(type)) throw new Error('bad file');
          var name = String(p['Upload jouw design'] || '') || decodeURIComponent(url.pathname.split('/').pop() || 'ontwerp');
          return { side: p.Kant, pos: p.Positie, fmt: p.Formaat, file: new File([blob], name, { type: type }) };
        }).catch(function (e) { warn('extra ontwerp ' + p.Ontwerp + ' not restored: ' + e.message); return null; });
      }));
    }).then(function (rows) {
      rows = (rows || []).filter(Boolean);
      if (!rows.length) return;
      var tries = 0, t = setInterval(function () {
        if (window.TTExtras && window.TTExtras.restore) { clearInterval(t); window.TTExtras.restore(rows); }
        else if (++tries > 40) clearInterval(t);
      }, 150);
    }).catch(function (e) { warn('extra ontwerpen not restored: ' + e.message); });
  }

  function warn(why) { if (window.console) console.warn('tt-ontwerp-bewaar: ' + why); }

  function allowed(u) {
    var url;
    try { url = new URL(u); } catch (e) { return null; }
    if (url.protocol !== 'https:' || HOSTS.indexOf(url.hostname) < 0 || url.username || url.password) return null;
    return url;
  }

  function fail(input, why) {
    warn(why);
    var anchor = input.closest('[data-bp-drop]') || input.parentNode;
    if (!anchor || document.querySelector('[data-tt-ontwerp-fout]')) return;
    var box = document.createElement('div');
    box.className = 'bp__err';
    box.setAttribute('role', 'alert');
    box.setAttribute('data-tt-ontwerp-fout', '');
    box.hidden = false;
    var s = document.createElement('span');
    s.textContent = MSG;
    box.appendChild(s);
    anchor.parentNode.insertBefore(box, anchor.nextSibling);
  }

  function pickPlek() {
    if (!plek || plek === 'Overig') return;
    var btns = document.querySelectorAll('[data-tt-plek] .bp__plek-btn');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute('data-pos') === plek) { btns[i].click(); return; }
    }
  }

  function byText(sel, test) {
    var btns = document.querySelectorAll(sel);
    for (var i = 0; i < btns.length; i++) if (test(btns[i])) { btns[i].click(); return true; }
    return false;
  }
  function pickStijl() {
    if (!stijl) return;
    var s = stijl.toLowerCase();
    if (!byText('[data-bp-stijl] .bp__style', function (b) { return String(b.getAttribute('data-value') || '').toLowerCase().indexOf(s) === 0; })) warn('no style button for ' + JSON.stringify(stijl));
  }
  function pickFormaat() {
    var m = /(\d+)\s*x\s*(\d+)/i.exec(formaat);
    if (!m) { if (formaat) warn('unreadable formaat ' + JSON.stringify(formaat)); return; }
    var want = m[1] + 'x' + m[2];
    if (!byText('[data-bp-formaat] .bp__swatch', function (b) { var v = /(\d+)x(\d+)cm/.exec(String(b.getAttribute('data-value') || '').replace(/\s+/g, '')); return !!v && v[1] + 'x' + v[2] === want; })) warn('no format button for ' + want);
  }

  // The group name: one visible line at the top of the form and a visible line property "Groep" on the order
  // (a hidden input tied to the product form; tt-pdp.js copies every properties[...] of that form into the cart line).
  function showGroep(input) {
    if (document.querySelector('[data-tt-groep-mee]')) return;
    var root = input.closest('[id^="bp-"]') || input.closest('.bp') || input.parentNode;
    if (!root) return;
    if (!document.getElementById('tt-groep-mee-css')) {
      var st = document.createElement('style');
      st.id = 'tt-groep-mee-css';
      st.textContent = '.tt-groep-mee{margin:0 0 var(--tt-space-3,12px);padding:var(--tt-space-2,8px) var(--tt-space-3,12px);border:1px solid var(--tt-line,#3A3A40);border-radius:var(--tt-radius-control,999px);font-size:var(--tt-fs-small,14px);line-height:1.4;overflow-wrap:anywhere}.tt-groep-mee strong{font-weight:700}';
      document.head.appendChild(st);
    }
    var p = document.createElement('p');
    p.className = 'tt-groep-mee';
    p.setAttribute('data-tt-groep-mee', '');
    p.setAttribute('role', 'status');
    p.appendChild(document.createTextNode('Je bestelt mee met '));
    var b = document.createElement('strong');
    b.textContent = groep;
    p.appendChild(b);
    p.appendChild(document.createTextNode('.'));
    root.insertBefore(p, root.firstChild);
    var h = document.createElement('input');
    h.type = 'hidden'; h.name = 'properties[Groep]'; h.value = groep;
    var fid = input.getAttribute('form');
    if (fid) h.setAttribute('form', fid);
    root.appendChild(h);
  }

  // A typed text: switch tt-borduurtekst.js to "Typ een naam of tekst", fill it, pick the font and thread colour. It draws the PNG itself.
  function typeText(done) {
    var tries = 0, t = setInterval(function () {
      var root = document.querySelector('[data-tt-btx]');
      if (!(window.TTBorduurtekst && root)) { if (++tries > 40) { clearInterval(t); warn('no text field on this page'); done(false); } return; }
      clearInterval(t);
      var mode = root.querySelector('[data-tt-btx-modus="tekst"]'), inp = root.querySelector('[data-tt-btx-in]');
      if (!mode || !inp) { done(false); return; }
      mode.click();
      inp.value = tekst.slice(0, parseInt(root.getAttribute('data-max'), 10) || 40);
      inp.dispatchEvent(new Event('input', { bubbles: true }));
      var f = font.toLowerCase(), k = kleur.toLowerCase();
      if (f && !byText('[data-tt-btx-font]', function (b) { return String(b.getAttribute('data-label') || '').toLowerCase() === f; })) warn('no font ' + JSON.stringify(font));
      if (k && !byText('[data-tt-btx-kleur]', function (b) { return String(b.getAttribute('data-label') || '').toLowerCase() === k; })) warn('no thread colour ' + JSON.stringify(kleur));
      done(true);
    }, 150);
  }

  // r20upload (f:ontwerp-hergebruiken): a customer who already has a design in the cart and opens ANOTHER product gets a calm choice at
  // step 1: "Gebruik je ontwerp van <product>", thumbnail and file name, at most 3, newest line first (cart.js lists the newest line first).
  // One tap puts that file in the upload field through loadFile (same host check, same change event). Place, style and format stay empty.
  // No cart or no design line: nothing is shown and the only request is the one GET /cart.js. The holder is [data-bp-hergebruik] in the snippet.
  function offer(input) {
    var host = document.querySelector('[data-bp-hergebruik]');
    var m = /\/products\/([^/?#]+)/.exec(location.pathname);
    if (!host || !m || raw || tekst) return;
    var handle = decodeURIComponent(m[1]), titel = host.getAttribute('data-t-titel') || 'Gebruik je ontwerp van';
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (c) {
      var items = c.items || [], seen = {}, list = [], i;
      for (i = 0; i < items.length && list.length < 3; i++) {
        var p = items[i].properties || {};
        if (!p._Ontwerpbestand || p.Ontwerp || p._tt_toeslag || items[i].handle === handle) continue;
        var url = allowed(String(p._Ontwerpbestand));
        if (!url) { warn('cart design refused ' + JSON.stringify(String(p._Ontwerpbestand).slice(0, 80)) + ' (only https from ' + HOSTS.join(' or ') + ')'); continue; }
        if (seen[url.href]) continue;
        seen[url.href] = 1;
        list.push({ url: url, product: String(items[i].product_title || items[i].title || ''), name: String(p['Upload jouw design'] || '') || decodeURIComponent(url.pathname.split('/').pop() || 'ontwerp') });
      }
      if (!list.length || (input.files && input.files.length)) return;
      if (!document.getElementById('tt-hergebruik-css')) {
        var st = document.createElement('style');
        st.id = 'tt-hergebruik-css';
        st.textContent = '.bp__hergebruik{display:flex;flex-direction:column;gap:var(--tt-space-2,8px);margin:0 0 var(--tt-space-3,12px)}'
          + '.bp__hergebruik[hidden]{display:none}'
          + '.bp__hergebruik-knop{display:flex;align-items:center;gap:var(--tt-space-3,12px);width:100%;min-height:56px;padding:var(--tt-space-2,8px) var(--tt-space-3,12px);border:1px solid var(--tt-line,#3A3A40);border-radius:var(--tt-radius-card,12px);background:var(--tt-surface,transparent);color:var(--tt-text,inherit);font:inherit;text-align:left;cursor:pointer}'
          + '.bp__hergebruik-knop:hover{border-color:var(--tt-text,currentColor)}'
          + '.bp__hergebruik-knop:focus-visible{outline:2px solid var(--tt-text,currentColor);outline-offset:2px}'
          + '.bp__hergebruik-img{flex:0 0 auto;width:40px;height:40px;object-fit:contain;border-radius:var(--tt-radius-swatch,6px);background:var(--tt-surface-2,transparent)}'
          + '.bp__hergebruik-tekst{display:flex;flex-direction:column;min-width:0;line-height:1.3}'
          + '.bp__hergebruik-tekst strong{font-size:var(--tt-fs-small,14px);font-weight:700;overflow-wrap:anywhere}'
          + '.bp__hergebruik-tekst span{font-size:var(--tt-fs-small,14px);color:var(--tt-text-muted,inherit);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}';
        document.head.appendChild(st);
      }
      list.forEach(function (d) {
        var b = document.createElement('button'), img = document.createElement('img'), t = document.createElement('span'), s1 = document.createElement('strong'), s2 = document.createElement('span');
        b.type = 'button'; b.className = 'bp__hergebruik-knop'; b.setAttribute('data-bp-hergebruik-knop', d.url.href);
        img.className = 'bp__hergebruik-img'; img.alt = ''; img.width = 40; img.height = 40; img.loading = 'lazy'; img.src = d.url.href;
        t.className = 'bp__hergebruik-tekst';
        s1.textContent = titel + (d.product ? ' ' + d.product : '');
        s2.textContent = d.name;
        t.appendChild(s1); t.appendChild(s2); b.appendChild(img); b.appendChild(t);
        b.addEventListener('click', function () { loadFile(input, d.url.href); });
        host.appendChild(b);
      });
      host.hidden = false;
      input.addEventListener('change', function () { host.hidden = true; });
    }).catch(function (e) { warn('cart design not offered: ' + e.message); });
  }

  function load(input) {
    offer(input);
    if (noLink) return;
    pickPlek();
    if (linkMode) { pickStijl(); pickFormaat(); }
    if (groep) showGroep(input);
    if (tekst && linkMode) { typeText(function (ok) { if (!ok && raw) loadFile(input); }); return; }
    if (raw) loadFile(input);
  }

  function loadFile(input, from) {
    from = from || raw;
    var url = allowed(from);
    if (!url) { fail(input, 'refused ontwerp ' + JSON.stringify(from.slice(0, 80)) + ' (only https from ' + HOSTS.join(' or ') + ')'); return; }
    fetch(url.href, { credentials: 'omit', mode: 'cors' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.blob();
    }).then(function (blob) {
      if (!blob.size || blob.size > MAX) throw new Error('size ' + blob.size);
      var name = decodeURIComponent(url.pathname.split('/').pop() || 'ontwerp');
      var type = blob.type || '';
      if (!/^(image\/|application\/pdf)/.test(type)) throw new Error('type ' + type);
      var dt = new DataTransfer();
      dt.items.add(new File([blob], name, { type: type }));
      input.files = dt.files;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }).catch(function (e) { fail(input, 'could not load ' + url.href + ': ' + e.message); });
  }

  function start() {
    var input = document.querySelector('[data-bp-file]');
    if (input) { load(input); return; }
    var tries = 0, t = setInterval(function () {
      input = document.querySelector('[data-bp-file]');
      if (input) { clearInterval(t); load(input); }
      else if (++tries > 40) { clearInterval(t); warn('no upload field on this page'); }
    }, 150);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
